/* eslint-disable no-undef */
class GrapheneHCSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    this.open = false

    this.setupListeners()
  }

  setupListeners () {
    this.handleOpen = this.handleOpen.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleClear = this.handleClear.bind(this)
    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.input.element.addEventListener('click', this.handleOpen)
    this.els.input.element.addEventListener('input', this.handleInput)

    if (this.els?.close?.exists) {
      this.els.close.element.addEventListener('click', this.handleClose)
    }

    if (this.els?.clear?.exists) {
      this.els.clear.element.addEventListener('click', this.handleClear)
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.element.addEventListener(
        'click',
        this.handleTrigger
      )
    }

    document.addEventListener('click', event => {
      if (event.target.closest(this.els.input.selector)) return
      if (event.target.closest(this.externalEls.results.selector)) return
      if (event.target.closest(this.externalEls.trigger.selector)) return
      if (this.els?.clear?.exists) {
        if (event.target.closest(this.els.clear.selector)) return
      }

      this.handleClose()
    })
  }

  handleInput (event) {
    const className = 'gqs-QuickSearch_Input'

    if (event.target.value.length > 0) {
      document.body.classList.add(className)
    } else {
      document.body.classList.remove(className)
    }
  }

  handleTrigger (event) {
    this.handleOpen(event)
    this.els.input.element.focus()
  }

  handleClear () {
    this.els.input.element.value = ''
    this.els.input.element.focus()
  }

  handleOpen (event) {
    if (this.open === true) return

    this.open = true
    document.body.classList.add('gqs-QuickSearch_Open')
  }

  handleClose (event) {
    if (this.open === false) return

    this.open = false
    document.body.classList.remove('gqs-QuickSearch_Open')
  }
}

if (!customElements.get('graphenehc-search')) {
  customElements.define('graphenehc-search', GrapheneHCSearch)
}
